var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F3F3F9",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1502 22.5502L13.4502 21.8502L17.3002 18.0002L13.4502 14.1502L14.1502 13.4502L18.0002 17.3002L21.8502 13.4502L22.5502 14.1502L18.7002 18.0002L22.5502 21.8502L21.8502 22.5502L18.0002 18.7002L14.1502 22.5502Z",
    fill: "#3A3A3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRounded);
export default __webpack_public_path__ + "static/media/close_rounded.36b9b1c44d5a2b83cdb0282a1a9959a3.svg";
export { ForwardRef as ReactComponent };